<div class="mt-2 mb-2">
  <mat-accordion>
    <mat-expansion-panel [expanded]="panelOpenState()" (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)">
      <mat-expansion-panel-header class="borderBottom">
        <mat-panel-title><span class="title">Localizzazione Geografico - Amministrativa</span></mat-panel-title>
        <mat-panel-description class="justify-content-end">
          @if (!saved) {
<i class="bi bi-exclamation-circle-fill" style="color: red; font-size: large;"></i>
}
          @if (saved) {
<i class="bi bi-check-circle-fill" style="color: green; font-size: large;"></i>
}
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid p-1 p-lg-2">
        <form [formGroup]="geographicForm">


          <div class="row justify-content-start align-items-center borderTop mt-3">
            <div class="col-12 mt-2 text-center">
              <span class="subTitle">Collocazione specifica</span>
            </div>
            <div class="col-12 col-md-8">
              <label for="specifications" class="form-label" style="font-weight: bold;">
                Specifiche<sup>*</sup>
              </label>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="" id="specifications"
                  formControlName="specifications" [class.is-invalid]="geographicForm.get('specifications')?.invalid &&
                                      (submitted || geographicForm.get('specifications')?.dirty)">
              </div>
              @if (geographicForm.get('specifications')?.errors?.['maxlength']
              && geographicForm.get('specifications')?.dirty) {
<div>
                <span style="font-size: x-small; color: red;">Max 250 caratteri</span>
              </div>
}

            </div>
          </div>


        </form>

        <div class="row justify-content-center mt-4 borderTop">
          @if (geographicForm.invalid && submitted) {
<div class="col-12 mt-2 text-center">
            <small>Compilare correttamente tutti i campi obbligatori per abilitare il
              salvataggio
            </small>
          </div>
}
          <div class="col-12 col-md-6 col-lg-4 mt-1 text-center">
            <button class="btn btn-outline-dark" (click)="save()">Salva</button>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
